module.exports = __webpack_public_path__ + "img/41.ef31e6b1.png";